import React from 'react';
import { StyledButton, StyledLink, VariantProps } from './styles';

type BaseProps = {
  variant?: VariantProps;
  children: React.ReactNode;
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  as: 'button';
}

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  as: 'a';
}

type LinkButtonProps = BaseProps & (ButtonProps | LinkProps);

export const LinkButton = ({
  as = 'button',
  variant = 'default',
  children,
  ...rest
}: LinkButtonProps) => {
  if (as === 'a') {
    return (
      <StyledLink variant={variant} {...(rest as LinkProps)}>
        {children}
      </StyledLink>
    );
  }

  return (
    <StyledButton variant={variant} {...(rest as ButtonProps)}>
      {children}
    </StyledButton>
  );
};
